import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import {
  CATEGORIE_EXPERTISE_OPTIONS,
  FORMAT_RAPPORT_OPTIONS,
  TYPE_VALEUR_OPTIONS,
  OCCUPATION_OPTIONS,
  DESTINATION_BIEN_OPTIONS,
  ETAT_BIEN_OPTIONS,
  QUALITE_DONNEUR_ORDRE_OPTIONS,
} from '@/constants/enums';

export default function SectionMission({ data, onChange }) {
  const handleChange = (field) => (e) => onChange(field, e.target.value);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <Select
        label="Catégorie d'expertise *"
        name="categorie_expertise"
        value={data.categorie_expertise || ''}
        options={CATEGORIE_EXPERTISE_OPTIONS}
        onChange={handleChange('categorie_expertise')}
        required
      />
      <Select
        label="Format du rapport"
        name="format_rapport"
        value={data.format_rapport || ''}
        options={FORMAT_RAPPORT_OPTIONS}
        onChange={handleChange('format_rapport')}
      />
      <Select
        label="Type de valeur *"
        name="type_valeur"
        value={data.type_valeur || ''}
        options={TYPE_VALEUR_OPTIONS}
        onChange={handleChange('type_valeur')}
        required
      />
      <Select
        label="Occupation *"
        name="occupation"
        value={data.occupation || ''}
        options={OCCUPATION_OPTIONS}
        onChange={handleChange('occupation')}
        required
      />
      <Select
        label="Destination du bien"
        name="destination"
        value={data.destination || ''}
        options={DESTINATION_BIEN_OPTIONS}
        onChange={handleChange('destination')}
      />
      <Select
        label="État du bien"
        name="etat"
        value={data.etat || ''}
        options={ETAT_BIEN_OPTIONS}
        onChange={handleChange('etat')}
      />
      <Input
        label="Usage maintenu"
        name="usage_maintenu"
        value={data.usage_maintenu || ''}
        onChange={handleChange('usage_maintenu')}
      />
      <Select
        label="Qualité du donneur d'ordre"
        name="qualite_donneur_ordre"
        value={data.qualite_donneur_ordre || ''}
        options={QUALITE_DONNEUR_ORDRE_OPTIONS}
        onChange={handleChange('qualite_donneur_ordre')}
      />
      <Input
        label="Accompagnant"
        name="accompagnant"
        value={data.accompagnant || ''}
        onChange={handleChange('accompagnant')}
      />

      <div className="col-span-1 md:col-span-2 lg:col-span-3">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Input
            label="Date de visite"
            name="date_visite"
            type="date"
            value={data.date_visite || ''}
            onChange={handleChange('date_visite')}
          />
          <Input
            label="Date du rapport"
            name="date_rapport"
            type="date"
            value={data.date_rapport || ''}
            onChange={handleChange('date_rapport')}
          />
          <Input
            label="Date de valorisation"
            name="date_valorisation"
            type="date"
            value={data.date_valorisation || ''}
            onChange={handleChange('date_valorisation')}
          />
        </div>
      </div>
    </div>
  );
}
